'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var PropTypes = _interopDefault(require('prop-types'));
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var _babelHelpers = require('../_babelHelpers-48e7a7f7.js');
var style$1 = require('../style-222d2b0f.js');

var _templateObject = _babelHelpers.taggedTemplateLiteral(["\n  ", ";\n"], ["\n  ", ";\n"]);

var Span = styled__default.span(_templateObject, style$1.textStyle);
Span.propTypes = {
  color: PropTypes.string,
  bold: PropTypes.bool,
  semiBold: PropTypes.bool,
  light: PropTypes.bool,
  weight: PropTypes.string,
  opacity: PropTypes.string,
  fontStyle: PropTypes.string,
  size: PropTypes.string,
  lineHeight: PropTypes.string,
  leftSpace: PropTypes.string,
  rightSpace: PropTypes.string,
  margin: PropTypes.string,
  mt: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  mb: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  mr: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  ml: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  m0: PropTypes.bool,
  maxWidth: PropTypes.string,
  align: PropTypes.string,
  lineThrough: PropTypes.bool,
  underline: PropTypes.bool,
  decoration: PropTypes.string,
  center: PropTypes.bool,
  letterSpacing: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  padding: PropTypes.string,
  mColor: PropTypes.string,
  mSize: PropTypes.string,
  mWidth: PropTypes.string,
  mMargin: PropTypes.string,
  mCenter: PropTypes.bool,
  mHideMobile: PropTypes.bool
};

Span.defaultProps = {
  color: "inherit"
};

module.exports = Span;
//# sourceMappingURL=span.js.map
